import { PAYMENT_METHODS } from "./Constants";

// Until the API sends refund_supported, keep the old rule: Braintree-era rows (or no row) stay as before.
export const isRefundSupported = (transaction) => {
  if (transaction && typeof transaction.refund_supported === "boolean") {
    return transaction.refund_supported;
  }
  return transaction?.payment_method !== PAYMENT_METHODS.BRAINTREE;
};
